// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { Behavior } from "./Behaviours";
import { BehaviorEnumValidator, BehaviorMapValidator, BehaviorValueValidator, ClickAnalyticsPlugin } from "./ClickAnalyticsPlugin";
export { Behavior, ClickAnalyticsPlugin, BehaviorMapValidator, BehaviorValueValidator, BehaviorEnumValidator };
//# sourceMappingURL=applicationinsights-clickanalytics-js.js.map